"use client"

import { Img } from "@/components/ui/image"
import { AppChannel, Channel } from "@/config/channel"
import { useConfigParams } from "@/hooks"
import { triggerSurveyBasedOnPathnameSisal } from "@/lib/sandsiv/survey-utils-sisal"
import Link from "next/link"
import { BaseCloseButton } from "../base-close-button"
import { AppChannelsWithoutHeader } from "../header-config"
import { useCloseWithSurveyAction } from "../header-hooks"
import { SiteHeader } from "../site-header"

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const AppChannelsWithoutCloseButton: Channel[] = [
  AppChannel.AppMobileMobileSisalIt,
  AppChannel.AppRouletteGiocaOnLine,
]

const SisalHeader = ({ isThankYouPage }: { isThankYouPage?: boolean }) => {
  /*--------------------hooks--------------------*/
  const { channel } = useConfigParams()

  const handleCloseClick = useCloseWithSurveyAction(
    !!isThankYouPage,
    triggerSurveyBasedOnPathnameSisal,
  )

  /*--------------------config--------------------*/
  const isLinkHeader = channel === AppChannel.PortaleWebFullResponsiveWwwSisalIt
  const hideSiteHeader =
    channel != null && AppChannelsWithoutHeader.includes(channel)
  const showCloseButton = !AppChannelsWithoutCloseButton.includes(channel)

  if (hideSiteHeader) return null

  return (
    <SiteHeader id="site-header">
      {isLinkHeader ? (
        <Link href={{ href: window.APP_MAIN_SITE_HOMEPAGE }} title="Sisal">
          <AppLogo />
        </Link>
      ) : (
        <AppLogo />
      )}
      {showCloseButton && <BaseCloseButton onClick={handleCloseClick} />}
    </SiteHeader>
  )
}

function AppLogo() {
  return <Img src={"/logo/logo-sisal.svg"} alt="logo" width={114} height={28} />
}

export { SisalHeader }
